import PreLoader from './PreLoader';
export default PreLoader;
